import {mapValueKeys} from '@shared/helpers/object'

import {DeliveryFeeClass} from '@web/core/constants'
import {DeliveryGroupState} from '@web/slices/deliveryGroup/slice'

import {Delivery} from '../apis/response/interface'

type DeliveryGroupKey = Delivery['deliveryGroupsByKey']

// DeliveryGroupKey 타입에서 deliveryPolicy.membershipFreeConditionalAmount 만 optional하게 변경한 타입
type RefineDeliveryGroupKey = Record<
    keyof DeliveryGroupKey,
    Omit<DeliveryGroupKey[keyof DeliveryGroupKey], 'deliveryPolicy'> & {
        deliveryPolicy: PartialField<
            DeliveryGroupKey[keyof DeliveryGroupKey]['deliveryPolicy'],
            'membershipFreeConditionalAmount'
        >
    }
>

export function convertDeliveryGroupsByKey(
    deliveryGroupsByKey: DeliveryGroupKey | RefineDeliveryGroupKey,
): DeliveryGroupState['deliveryGroupsByKey'] {
    return mapValueKeys((deliveryGroupItem) => {
        return {
            additionalDeliveryFee: deliveryGroupItem.additionalDeliveryFee,
            deliveryFee: deliveryGroupItem.deliveryFee,
            deliveryFeePayType: deliveryGroupItem.deliveryFeePayType ?? DeliveryFeeClass.FREE,
            deliveryFeeDiscountAmount: null,
            deliveryPolicy: {
                baseFee: deliveryGroupItem.deliveryPolicy.baseFee,
                deliveryArea2ExtraFee: deliveryGroupItem.deliveryPolicy.deliveryArea2ExtraFee,
                deliveryArea3ExtraFee: deliveryGroupItem.deliveryPolicy.deliveryArea3ExtraFee,
                deliveryAreaType: deliveryGroupItem.deliveryPolicy.deliveryAreaType,
                deliveryFeeClassType: deliveryGroupItem.deliveryPolicy.deliveryFeeClassType,
                deliveryFeePayType: deliveryGroupItem.deliveryPolicy.deliveryFeePayType ?? DeliveryFeeClass.FREE,
                deliveryMethodType: deliveryGroupItem.deliveryPolicy.deliveryMethodType,
                freeConditionalAmount: deliveryGroupItem.deliveryPolicy.freeConditionalAmount,
                membershipFreeConditionalAmount:
                    deliveryGroupItem.deliveryPolicy.membershipFreeConditionalAmount ?? undefined,
                repeatQuantity: deliveryGroupItem.deliveryPolicy.repeatQuantity,
                secondBaseQuantity: deliveryGroupItem.deliveryPolicy.secondBaseQuantity,
                secondExtraFee: deliveryGroupItem.deliveryPolicy.secondExtraFee,
                thirdBaseQuantity: deliveryGroupItem.deliveryPolicy.thirdBaseQuantity,
                thirdExtraFee: deliveryGroupItem.deliveryPolicy.thirdExtraFee,
                additionalFeeMessage: null,
            },
        }
    }, deliveryGroupsByKey)
}
